import React from 'react';
import {Grid} from '@mui/material';
import SupplierBookingCardItem from './SupplierBookingCardItem';
import NoMatchingInvoicesFound from '../../NoMatchingInvoicesFound';
import {supplierHeaderCells} from './data.js';

const SupplierBookingCardList = (props) => {
  const {bookings, rootStyle, userIsAdmin, handleSelectAdjustBooking, handleUpdatePendingBooking, pendingBookingUpdate} = props;

  const message = "No matching bookings found";

  return (
    bookings.length ?
      bookings.map((booking) => <SupplierBookingCardItem key={booking.id} booking={booking}
                                                                  headerCells={supplierHeaderCells}
                                                                  rootStyle={rootStyle} userIsAdmin={userIsAdmin}
                                                                  handleSelectAdjustBooking={handleSelectAdjustBooking}
                                                                  handleUpdatePendingBooking={handleUpdatePendingBooking}
                                                                  pendingBookingUpdate={pendingBookingUpdate}/>)
      : <Grid item container>
        <NoMatchingInvoicesFound message={message}/>
      </Grid>
  );
}

export default SupplierBookingCardList;